import { getBooleanFromValue, isFunction, isObject, isSet } from '@/global/utils/utils'
import { api } from '@/global/services/api'

const TAB_KEY = 'fuelProbe1'
const CALIBRATION_VALUES_DATA_KEY = 'calibration_values_1'
export default {
  data () {
    return {
      fuelProbe1InputTypeExists: false,
      fuelProbe1CurrentValueLoading: false
    }
  },

  computed: {
    fuelProbe1Config () {
      return {
        title: this.$t('base/tracker.fuel_probe_1'),
        key: TAB_KEY,
        visible: getBooleanFromValue(this.permissions?.canReadFuelProbes),
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/fuel-probe/1`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/fuel-probe/1`
          }
        },
        dataFetched: (event) => this.onFuelProbe1DataFetched(event, event?.data?.data),
        afterSave: (event, data) => this.onFuelProbe1DataFetched(event, data),
        afterCancel: (event) => this.onFuelProbe1DataFetched(event, event?.formDataForSend),
        modifyDataBeforeSend: (event) => this.onModifyFuelProbe1BeforeSend(event),
        hiddenFormKeys: [
          CALIBRATION_VALUES_DATA_KEY
        ],
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.fuel_probe_1'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'fuel_probe_status_1',
                    label: this.$t('base/tracker.fuel_probe_status'),
                    type: 'autocomplete',
                    items: [
                      {
                        id: 1,
                        name: this.$t('base.active')
                      },
                      {
                        id: 0,
                        name: this.$t('base.inactive')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'input_type_1_id',
                    label: this.$t('base/tracker.probe_attribute_input_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'probe-attribute-input-types'
                    },
                    onChange: (event) => {
                      this.fuelProbe1InputTypeExists = getBooleanFromValue(event?.selectedItem)
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'declared_tank_capacity_1',
                    label: this.$t('base/tracker.declared_tank_capacity'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'max_real_tank_capacity_1',
                    label: this.$t('base/tracker.max_real_tank_capacity'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'refuel_tolerance_1',
                    label: this.$t('base/tracker.refuel_tolerance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'fuel_leak_tolerance_1',
                    label: this.$t('base/tracker.fuel_leak_tolerance'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'samples_size_1',
                    label: this.$t('base/tracker.fuel_leak_samples_size'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'calibration_unit_1',
                    label: this.$t('base/tracker.calibration_unit'),
                    type: 'autocomplete',
                    items: [
                      {
                        id: 0,
                        name: this.$t('base/tracker.percentage')
                      },
                      {
                        id: 1,
                        name: this.$t('base/tracker.liters')
                      }
                    ],
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'max',
                    label: this.$t('base/tracker.max_liters'),
                    field_type: 'number',
                    creatable: true,
                    editable: true,
                    readonly: !this.fuelProbe1InputTypeExists,
                    visible: true
                  },
                  {
                    key: 'current_value',
                    label: this.$t('base/tracker.current_value'),
                    field_type: 'number',
                    appendIcon: this.fuelProbe1InputTypeExists ? 'mdi-sync' : '',
                    appendLoading: this.fuelProbe1CurrentValueLoading,
                    appendIconClick: (event) => this.onFuelProbe1GetCurrentValue(event),
                    creatable: false,
                    editable: false,
                    readonly: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            type: 'dynamic-columns',
            showButtons: false,
            component: this.dynamicColumnsContentComponent,
            title: this.$t('base/tracker.calibration_values'),
            key: CALIBRATION_VALUES_DATA_KEY,
            display_props: ['new_value', 'current_value'],
            headers: [this.$t('base/tracker.new_value'), this.$t('base/tracker.current_value')],
            fields: [
              {
                key: 'new_value',
                field_type: 'number',
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'current_value',
                field_type: 'number',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onModifyFuelProbe1BeforeSend (event) {
      const { copiedData } = event || {}
      if (copiedData?.[CALIBRATION_VALUES_DATA_KEY]?.length) {
        copiedData[CALIBRATION_VALUES_DATA_KEY] = copiedData[CALIBRATION_VALUES_DATA_KEY].reduce((acc, item) => {
          acc[item.new_value] = item.current_value
          return acc
        }, {})
        if (isSet(copiedData?.max)) {
          copiedData[CALIBRATION_VALUES_DATA_KEY].max = copiedData.max
        }
      }
      else {
        delete copiedData[CALIBRATION_VALUES_DATA_KEY]
      }
      return copiedData
    },

    onFuelProbe1DataFetched (event, data) {
      const { updateData, updateFormData } = event || {}
      const updateDataCallback = isFunction(updateData)
        ? updateData
        : (isFunction(updateFormData)
            ? updateFormData
            : null
          )
      if (isSet(data) && isObject(data) && isFunction(updateDataCallback)) {
        const calibrationValues = []
        if (isSet(data?.calibration_values) && isObject(data.calibration_values)) {
          Object.keys(data.calibration_values).forEach(key => {
            const calibrationValue = data.calibration_values?.[key]
            if (key === 'max') {
              updateDataCallback({
                max: calibrationValue
              })
            }
            else {
              calibrationValues.push({
                new_value: key,
                current_value: calibrationValue
              })
            }
          })
        }

        const inputType = data?.input_type?.id || data?.input_type
        updateDataCallback({
          [CALIBRATION_VALUES_DATA_KEY]: calibrationValues,
          fuel_probe_status_1: data?.is_active,
          input_type_1_id: inputType,
          declared_tank_capacity_1: data?.declared_tank_capacity,
          max_real_tank_capacity_1: data?.max_real_tank_capacity,
          refuel_tolerance_1: data?.refuel_tolerance,
          fuel_leak_tolerance_1: data?.fuel_leak_tolerance,
          samples_size_1: data?.samples_size,
          calibration_unit_1: [1, '1'].includes(data?.is_calibration_in_liters) ? 1 : 0
        })

        this.fuelProbe1InputTypeExists = getBooleanFromValue(inputType)
      }
    },

    async onFuelProbe1GetCurrentValue (event) {
      try {
        const { updateData } = event || {}
        if (!isFunction(updateData)) {
          return
        }

        this.fuelProbe1CurrentValueLoading = true
        const data = await api('base').get('current-fuel-probe-value', {
          trackerId: this.$route?.params?.id,
          probeNumber: 1
        })
        const { value } = data || {}
        if (!isSet(value)) {
          return
        }

        updateData({
          current_value: value
        })
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.fuelProbe1CurrentValueLoading = false
      }
    }
  }
}
